// @flow

import React      from 'react';
import moment     from 'moment';

const ToEarly = ({ translate, currentApp, ableToSendDate } : { translate: any, currentApp: Object, ableToSendDate: any }) => (
  <div className="reminder--body reminder--padded">
    <div className="reminder--clock-ico" />
    <h3 className="reminder--orange text-center">{translate('reminder.cant_yet')}</h3>
    <h4 className="reminder--orange text-center reminder--subheader">
      {translate('reminder.you_will_be_able', { date: ableToSendDate.format('DD.MM.YYYY') })}
    </h4>
    <span className="text-center">
      {translate('reminder.was_created', { date: moment(currentApp.created_at).format('DD.MM.YYYY') }) }
    </span>
  </div>
);

export default ToEarly;



// WEBPACK FOOTER //
// ./src/components/main/InsuranceInquiry/reminder/toEarly.js